<template>
  <div class="text-center">
    <v-overlay>
      <v-progress-circular 
        indeterminate 
        size="120"
        width="7"
        color="grey darken-2"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
  export default {}
</script>

<style lang="scss">
.v-overlay__scrim {
  background-color: transparent !important;
}
</style>